const defaultTheme = require("tailwindcss/defaultTheme");

module.exports = {
  purge: {
    enabled: false,
    content: ["./templates/**/*.{twig,html}", "./src/vue/**/*.{vue,html}"],
  },
  theme: {
    screens: {
      ...defaultTheme.screens,
      "2xl": "1536px",
    },
    fontFamily: {
      sans: [
        "AvertaStd",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        '"Noto Sans"',
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"',
      ],
    },
    colors: {
      transparent: "transparent",
      "transparent!": "transparent !important",
      black: "black",
      midnight: "#181C19",
      white: "white",
      snow: "#F0F0F0",
      smoke: "#F9F9F9",
      grey: "#E2E3DE",
      "grey-dark": "#8A8989",
      "grey-darker": "#808080",
      "blue-darker": "#0A1920",
      cream: "#EFECE2",
      charcoal: "#363436",
      red: "#EB6B66",
      sand: "#F8ECDD",
      "sand-darker": "#D4C7AE",
      "wild-thyme": "#D8D7DC",
      slate: "#343E49",
      cyan: "cyan",
      pink: "#F1C7CC",
      green: "#6CB5A2",
      paint: "var(--paint)",
      theme: "var(--theme)",
    },
    extend: {
      fontSize: {
        xxxs: "8px",
        xxs: "10px",
        xs: "12px",
        sm: "14px",
        base: "16px",
        md: "18px",
        lg: "20px",
        xl: "24px",
        "2xl": "28px",
        "3xl": "32px",
        "4xl": "40px",
        "5xl": "48px",
        "6xl": "60px",
        "7xl": "80px",
      },
      spacing: {
        gs: "var(--gutter-size)",
        ogs: "var(--outside-gutter-size)",
        "ogs-large": "var(--outside-gutter-size-large)",
        shh: "var(--site-header-height)",
        smh: "var(--site-message-height)",
        "2px": "2px",
        1.25: "0.3125rem",
        1.5: "0.375rem",
        2.5: "0.625rem",
        2.75: "0.6875rem",
        7: "1.75rem",
        9: "2.25rem",
        10.5: "2.625rem",
        11: "2.75rem",
        12: "3rem",
        13: "3.25rem",
        14: "3.5rem",
        15: "3.75rem",
        18: "4.5rem",
        22: "5.5rem",
        24: "6rem",
        26: "6.5rem",
        28: "7rem",
        30: "7.375rem",
        34: "8.5rem",
        44: "11rem",
        46: "11.5rem",
        54: "13.5rem",
        60: "15rem",
        72: "18rem",
        "7/10": "70%",
        124: "31rem",
        full: "100%",
      },
      height: {
        window: "var(--window-height)",
        hero:
          "calc(var(--window-height) - var(--site-header-height) - var(--site-message-height))",
        3.75: "0.9375rem",
      },
      minHeight: {
        screen: "100vh",
        window: "var(--window-height)",
        hero:
          "calc(var(--window-height) - var(--site-header-height) - var(--site-message-height))",
        8: "2rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        36: "9rem",
        54: "13.5rem",
        68: "17rem",
        86: "21.5rem",
        124: "31rem",
        188: "47rem",
        244: "61rem",
      },
      maxHeight: {
        hero:
          "calc(var(--window-height) - var(--site-header-height) - var(--site-message-height))",
      },
      padding: {
        "4/7": "57%",
        "8/12": "66.666667%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
      },
      minWidth: {
        16: "4rem",
        30: "7.375rem",
        120: "30rem",
        fit: "fit-content",
      },
      maxWidth: {
        "7xl": "84rem",
      },
      opacity: {
        10: "0.10",
        30: "0.30",
        40: "0.40",
        60: "0.60",
        70: "0.70",
        "100!": "1 !important",
      },
      divideOpacity: {
        20: "0.2",
      },
      borderOpacity: {
        20: "0.2",
      },
      inset: {
        smh: "var(--site-message-height)",
        "1/2": "50%",
        full: "100%",
      },
      zIndex: {
        "-10": "-10",
        60: "60",
        70: "70",
        80: "80",
        90: "90",
        100: "100",
        9999: "9999",
      },
      borderRadius: {
        xs: "0.125rem",
        sm: "0.1875rem",
        xl: "1rem",
        "2xl": "1.25rem",
      },
      lineHeight: {
        tight: "1.2",
      },
      rotate: {
        16: "16deg",
        "-16": "-16deg",
      },
    },
  },
  variants: {
    translate: ["responsive", "hover", "focus", "group-hover"],
    opacity: ["responsive", "hover", "focus", "group-hover"],
    textDecoration: ["responsive", "hover", "focus", "group-hover"],
    zIndex: ["responsive", "hover"],
    display: ["responsive", "last"],
  },
  plugins: [],
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
  },
  experimental: {
    applyComplexClasses: true,
  },
};
